import React, { useEffect, useState } from 'react';
export function UrgencySection() {
  const [timeLeft, setTimeLeft] = useState(48 * 60 * 60);
  useEffect(() => {
    const storedStartTime = localStorage.getItem('urgencyStartTime');
    const now = Date.now();
    let startTime;
    if (storedStartTime) {
      startTime = parseInt(storedStartTime, 10);
    } else {
      startTime = now;
      localStorage.setItem('urgencyStartTime', startTime.toString());
    }
    const interval = setInterval(() => {
      const elapsedSeconds = Math.floor((Date.now() - startTime) / 1000);
      const remaining = Math.max(0, 48 * 60 * 60 - elapsedSeconds);
      setTimeLeft(remaining);
      if (remaining === 0) {
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <section className="w-full py-2 px-4 bg-[#D4507A]" data-id="element-150">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-3 text-center" data-id="element-151">
        <p className="text-white font-semibold text-xs sm:text-sm" data-id="element-152">
          ⏰ PRECIO DE LANZAMIENTO — Oferta termina en:
        </p>
        <span className="text-white font-mono font-bold text-lg sm:text-xl tracking-widest" data-id="element-153">
          {formatTime(timeLeft)}
        </span>
      </div>
    </section>;
}